import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import * as serviceWorker from './serviceWorker';
import img10 from './img11.png';
import logo from './logo.jpg';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <div>
    <img className="img10" src={img10} />
    <div className="footer">
      <p>京 ICP 备 05032414 号 - 106 </p>
      <div className="footer_right">
        <img className="footer_logo" src={logo} alt="Logo" />
        Copyright ©启明星辰 版权所有
      </div>
    </div>
  </div>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
